<template>
  <div v-html="itemName"></div>
</template>

<script>
export default {
  computed: {
    row() {
      let row = this.config?.row
      if (_.isObjectLike(row)) {
        return row
      }
      return {}
    },
    itemName() {
      let timestamp = parseInt(this.row[this.config?.key]) || 0
      if (this.row[this.config?.key] && parseInt(this.row[this.config?.key].text || 0) > 0) {
        timestamp = parseInt(this.row[this.config?.key].text)
      }
      return timestamp > 0 ? this.$util.timestampToDateTime(timestamp, true) : '-'
    }
  },
  props: {
    config: Object
  },
  methods: {}
}
</script>
